import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { AuthService } from '../../../core/auth.service';
import { AppService } from '../../../app.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-admin-navigation',
    templateUrl: './navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./navigation.component.scss']
})
export class AdminSettingNavigationComponent implements OnInit {
    @Input() params: Object;
    @Input() type: Object;

    PAGES = []

    SERVICE_PROVIDER_PAGES = [
        {
            key: 'CATEGORIES',
            title: 'Categories',
            path: 'categories'
        },
        {
            key: 'SUBCATEGORIES',
            title: 'Sub-Categories',
            path: 'sub-categories'
        },
        {
            key: 'INSURANCES',
            title: 'Insurances',
            path: 'insurances'
        },
        {
            key: 'COMPANIES',
            title: 'Companies',
            path: 'companies'
        },
        {
            key: 'AGEGROUPS',
            title: 'Age groups',
            path: 'age-groups'
        },
        {
            key: 'DOMAINTEXTS',
            title: 'Domain texts',
            path: 'domain-texts'
        },
        {
            key: 'LOGOS',
            title: 'Logos',
            path: 'logos'
        },
        {
            key: 'SERVICEPROVIDERS',
            title: 'Service providers',
            path: 'service-providers'
        }
    ];

    SELF_REPORT_PAGES = [
        {
            key: 'DOMAINS',
            title: 'Domains',
            path: 'domains'
        },
        {
            key: 'SYMPTOMS',
            title: 'Symptoms',
            path: 'feelings'
        },
        {
            key: 'SR',
            title: 'Self reports',
            path: 'self-report'
        },
        {
            key: 'DIAGNOSIS',
            title: 'Diagnosis',
            path: 'diagnosis'
        },
        {
            key: 'LIFECIRCUMSTANCES',
            title: 'Life circumstances',
            path: 'life-circumstances'
        },
    ];
    url: string = '';

    currentPage: string;
    constructor(
        public authService: AuthService,
        public appService: AppService,
        public router: Router
    ) {
    }
    ngOnInit(){
        this.currentPage = this.params['page'] || '';

        if (this.type === 'SELF_REPORT') {
            this.PAGES = this.SELF_REPORT_PAGES;
            this.url = '/self-report-setting/';
        } else if (this.type === 'SEVICE_PROVIDER') {
            this.PAGES = this.SERVICE_PROVIDER_PAGES;
            this.url = '/service-provider-setting/';
        }
    }
    navigate(page){
        if(!page || !page['path']){
            return false;
        }
        return this.router.navigate([this.url, page['path']]);
    }
}
